import breakpoints from './breakpoints';
import colors from './colors';
import sizes from './sizes';
import space from './space';
import transitions from './transitions';
import typography from './typography';

const theme = {
  breakpoints,
  space,
  ...typography,
  transitions,
  header: {
    height: 128,
    mobileHeight: 64,
  },
  sizes,
  colors,
};

export type Theme = typeof theme;

export default theme;
